import { render, staticRenderFns } from "./ProductStorage.vue?vue&type=template&id=ab7ac0c8&scoped=true&lang=pug&"
import script from "./ProductStorage.vue?vue&type=script&lang=ts&"
export * from "./ProductStorage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductStorage.vue?vue&type=style&index=0&id=ab7ac0c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7ac0c8",
  null
  
)

export default component.exports